import { render, staticRenderFns } from "./FixedDepositTopup.vue?vue&type=template&id=0d84d98b&scoped=true&"
import script from "./FixedDepositTopup.vue?vue&type=script&lang=js&"
export * from "./FixedDepositTopup.vue?vue&type=script&lang=js&"
import style0 from "./FixedDepositTopup.vue?vue&type=style&index=0&id=0d84d98b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84d98b",
  null
  
)

export default component.exports